import { Share2 } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createSocialsFilterConfig(): FilterStringConfig {
  return {
    label: 'Socials',
    icon: <Share2 className="size-4" />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'equals', value: '' }),
    options: {
      placeholder: 'Search by social platform'
    }
  };
}
